import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './bootstrap.css';
import './styles.css';
const huPlayer = 'O';
const aiPlayer = 'X';
// var teller = 0;

function Square(props) {
  return (
    <button className="square" onClick={props.onClick}>
      {props.value}
    </button>
  );
}

class Board extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      squares: Array(9).fill(null),
      xIsStart: true,
      xIsNext: true,
      isAIplayer: true,
      playerText: 'X=AI vs O=Player',
      statTie: 0,
      statWinAI: 0,
      statWinHu: 0,
    };
    this.handleClick(bestSpot(this.state.squares));
  }

  handleClick(i) {
    // console.log('*** Click handleClick i:' + i);
    const squaresL = this.state.squares.slice();
    // console.log('*this.state.xIsNext:' + this.state.xIsNext);
    if (calculateWinner(squaresL) || squaresL[i]) {
      return;
    }
    squaresL[i] = this.state.xIsNext ? 'X' : 'O';
    // console.log('a. this.state.xIsNext : ' + this.state.xIsNext);
    this.setState({
      squares: squaresL,
      xIsNext: !this.state.xIsNext,
    });
    // console.log('b. this.state.xIsNext : ' + this.state.xIsNext);
    this.state.squares = squaresL;
    this.state.xIsNext = !this.state.xIsNext;
    // console.log('c. this.state.xIsNext : ' + this.state.xIsNext);

    let emptySquaresArr = emptySquares(squaresL);
    if (emptySquaresArr.length !== 0 && this.state.xIsNext && this.state.isAIplayer) {
      // console.log('emptySquaresArr:' + emptySquaresArr);
      // console.log('emptySquaresArr[0]:' + emptySquaresArr[0]);
      // console.log('this.state.xIsNext:' + this.state.xIsNext);
      this.handleClick(bestSpot(this.state.squares));
    }
    // console.log('*** End Click handleClick');
  }

  renderSquare(i) {
    return (
      <Square
        value={this.state.squares[i]}
        onClick={() => this.handleClick(i)}
      />
    );
  }

  // +  handleNewGame(squares, xIsStart, xIsNext) {
  handleNewGame() {
    // console.log('*** Click handleNewGame');
    this.state.squares.fill(null);
    // console.log('1. this.xIsStart: ' + this.state.xIsStart + ', xIsNext: ' + this.state.xIsNext);
    this.setState({
      xIsStart: !this.state.xIsStart,
      xIsNext: !this.state.xIsStart,
    });
    // console.log('2. this.xIsStart: ' + this.state.xIsStart + ', xIsNext: ' + this.state.xIsNext);
    this.state.xIsStart = !this.state.xIsStart;
    this.state.xIsNext = this.state.xIsStart;
    // console.log('3. this.xIsStart: ' + this.state.xIsStart + ', xIsNext: ' + this.state.xIsNext);

    if (this.state.isAIplayer && this.state.xIsStart) {
      this.handleClick(bestSpot(this.state.squares));
      // console.log('4. this.xIsStart: ' + this.state.xIsStart + ', xIsNext: ' + this.state.xIsNext);
    }
    // console.log('5. this.xIsStart: ' + this.state.xIsStart + ', xIsNext: ' + this.state.xIsNext);
    // console.log('*** End Click handleNewGame');
  }

  handleSwitchAI() {
    // console.log('*** Click handleSwitchAI ');
    let playerText = '';
    // console.log('I. this.state.isAIplayer: ' + this.state.isAIplayer);
    this.state.isAIplayer = !this.state.isAIplayer;
    // console.log('II. this.state.isAIplayer: ' + this.state.isAIplayer);

    this.state.isAIplayer ? playerText = 'X=AI vs O=Player       ' : playerText = 'X=Player1 vs O=Player2';
    this.setState({
      playerText: playerText,
      isAIplayer: this.state.isAIplayer,
    });
    // console.log('III. this.state.isAIplayer: ' + this.state.isAIplayer);

    this.handleNewGame();
    // console.log('*** End Click handleSwitchAI : ' + this.state.isAIplayer);
  }

  render() {
    const winner = calculateWinner(this.state.squares);
    let status;
    if (winner) {
      status = 'Winner: ' + winner;
      winner === aiPlayer ? this.state.statWinAI++ : this.state.statWinHu++;
    } else if (checkTie(this.state.squares)) {
      status = 'Tie game.';
      this.state.statTie++;
    } else {
      status = 'Next player: ' + (this.state.xIsNext ? 'X' : 'O');
    }

    return (
      <div>
        <div className="status">{status}</div>
        <div className="matrix">
          <div className="board-row">
            {this.renderSquare(0)}
            {this.renderSquare(1)}
            {this.renderSquare(2)}
          </div>
          <div className="board-row">
            {this.renderSquare(3)}
            {this.renderSquare(4)}
            {this.renderSquare(5)}
          </div>
          <div className="board-row">
            {this.renderSquare(6)}
            {this.renderSquare(7)}
            {this.renderSquare(8)}
          </div>        </div>
        <div className="stats">Win X: {this.state.statWinAI} Win O: {this.state.statWinHu} Tie: {this.state.statTie}</div>
        <div >
          <button className="buttonSwitchAI button btn btn-primary" onClick={() => this.handleSwitchAI(this.state.isAIplayer)}>
            {this.state.playerText}
            {/* {this.handleNewGame(this.state.squares)} */}
          </button>
        </div>
        <div >
          <button className="buttonNewGame button btn btn-primary" onClick={() => this.handleNewGame()}>
            New game
            {/* {this.handleNewGame(this.state.squares)} */}
          </button>
        </div>
      </div>
    );
  }
}

class Game extends React.Component {
  render() {
    return (
      <div>
        <div className="game">
          <div className="game-board">
            <Board />
          </div>
          <div className="game-info">
            <div>{/* status */}</div>
            <ol>{/* TODO */}</ol>
          </div>
        </div>
        <div>
          <div class="tab-pane pt-4 pl-5 pr-5" role="tabpanel" id="privacy">
            <div class="row mt-5">
              <div class="col-sm-12 ">
                <div class="card mb-4">
                  <div class="card-body text-left">
                    <h5 class="card-title">Tic-tac-toe</h5>
                    <p class="card-text">
                      This implementation of tic-tac-toe is done with HTML5, CSS3, JavaScript (ECMAScript 2016),
                      Bootstrap 4, React and JSX.<br />
                      The implemented artificial intelligence (AI) algorithm is the minimax algorithm.<br />
                      To prevent repetitive game behavior, a randomize function was added to equal score solutions.<br />
                      The game is hosted on the Heroku cloud service because Node.js is needed to run React.<br />
                      For deploying builds to Heroku, Heroku uses a Git based deployment mechanism.<br />
                      The building of this game was a trip down memory lane as I implemented this game also in my student days,
                      with a brute-force, tree traversal, recursive algorithm in ALGOL.<br />
                      Enjoy playing.
              </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class App extends React.Component {
  render() {
    return (
      <div>
        <Header />
        <Game />
        <Footer />
      </div>
    );
  }
}

class Header extends React.Component {
  render() {
    return (
      <div>
        <h1>Header</h1>
        <nav class="navbar navbar-expand-lg navbar-dark bg-primary fixed-top">
          <a class="navbar-brand" href="https://www.dahmen.nl">Dahmen Automatisering</a>
        </nav>
        <br></br>
      </div>
    );
  }
}

class Footer extends React.Component {
  render() {
    return (
      <div>
        <br></br>
        <br></br>
        <footer class="page-footer my-expand-lg font-small bg-primary text-white pt-4">
          <div class="container-fluid text-center text-md-left">
            <div class="row ">
              <div class="col-md-6 mt-md-0 mt-3">
                <h5 class="text-uppercase">Dahmen Automatisering</h5>
                <p>ICT advies, E-Commerce en websites.</p>
              </div>
            </div>
          </div>
          <div class="footer-copyright text-center py-3">&copy; 2019 Copyright:
                <a href="https://dahmen.nl" class="text-white"> Dahmen Automatisering</a>
          </div>
        </footer>
      </div>
    );
  }
}


// ========================================

ReactDOM.render(
  // <Game />,
  <App />,
  document.getElementById('root')
);

function calculateWinner(squares) {
  // console.log("squares win: "+squares);
  const lines = [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [0, 3, 6],
    [1, 4, 7],
    [2, 5, 8],
    [0, 4, 8],
    [2, 4, 6],
  ];
  for (let i = 0; i < lines.length; i++) {
    const [a, b, c] = lines[i];
    if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
      return squares[a];
    }
  }
  return null;
}

function emptySquares(squares) {
  let emptySquaresArr = [];
  for (let i = 0; i < squares.length; i++) {
    if (squares[i] == null) {
      emptySquaresArr.push(i);
    }
  }
  // console.log("emptySquaresArr: " + emptySquaresArr);
  return emptySquaresArr;
}

function emptySquaresNumbers(squares) {
  let emptySquaresArr = [];
  for (let i = 0; i < squares.length; i++) {
    if (squares[i] === i) {
      emptySquaresArr.push(i);
    }
  }
  return emptySquaresArr;
}
function checkTie(squares) {
  if (emptySquares(squares).length === 0) {
    return true;
  }
  return false;
}

function bestSpot(squares) {
  // console.log("*** bestSpot squares: " + squares);
  let level = 1;
  let tries = 1;
  let i = 0;
  let minimaxRes;
  for (i = 0; i < squares.length; i++) {
    if (squares[i] == null) { squares[i] = i; }
  }
  // teller = 0;
  minimaxRes = minimaxMove(squares, aiPlayer, level, tries);
  // console.log("minimaxRes.index: " + minimaxRes.index);
  // console.log("minimaxRes.score: " + minimaxRes.score);
  // console.log("minimaxRes.tries: " + minimaxRes.tries);
  // console.log("minimaxRes.win: " + minimaxRes.win);
  // console.log("minimaxRes.lose: " + minimaxRes.lose);
  // console.log("minimaxRes.tie: " + minimaxRes.tie);
  // console.log("teller: " + teller);
  for (i = 0; i < squares.length; i++) {
    if (squares[i] === i) { squares[i] = null; }
  }
  return minimaxRes.index;
}

function minimaxMove(newBoard, player, level, triesIn) {
  let availSpots = emptySquaresNumbers(newBoard);
  let winner = calculateWinner(newBoard);
  if (winner === huPlayer) {
    return { score: -10 + level, tries: triesIn, win: 0, lose: 1, tie: 0 };
  } else if (winner === aiPlayer) {
    return { score: 10 - level, tries: triesIn, win: 1, lose: 0, tie: 0 };
  } else if (availSpots.length === 0) {
    return { score: 0, tries: triesIn, win: 0, lose: 0, tie: 1 };
  }
  // teller++;
  let moves = [];
  let triesRes = 0;
  let winRes = 0;
  let loseRes = 0;
  let tieRes = 0;
  let result;
  let i = 0;
  for (i = 0; i < availSpots.length; i++) {
    var move = {};
    move.index = newBoard[availSpots[i]];
    newBoard[availSpots[i]] = player;
    // triesIn++;
    if (player === aiPlayer) {
      result = minimaxMove(newBoard, huPlayer, level + 1, 1);
    } else {
      result = minimaxMove(newBoard, aiPlayer, level + 1, 1);
    }
    move.score = result.score;
    move.tries = result.tries;
    move.win = result.win;
    move.lose = result.lose;
    move.tie = result.tie;
    // move.moves = result.moves;

    triesRes = triesRes + result.tries;
    winRes = winRes + result.win;
    loseRes = loseRes + result.lose;
    tieRes = tieRes + result.tie;

    newBoard[availSpots[i]] = move.index;

    moves.push(move);
  }

  var bestMove;
  let bestScores = [];
  let bestScore = 0;
  if (player === aiPlayer) {
    bestScore = -10000;
    for (i = 0; i < moves.length; i++) {
      if (moves[i].score >= bestScore) {
        bestScore = moves[i].score;
      }
    }
    for (move in moves) {
      if (moves[move].score === bestScore) {
        bestScores.push(moves[move]);
      }
    }
  } else {
    bestScore = 10000;
    for (i = 0; i < moves.length; i++) {
      if (moves[i].score <= bestScore) {
        bestScore = moves[i].score;
      }
    }
    for (move in moves) {
      if (moves[move].score === bestScore) {
        bestScores.push(moves[move]);
      }
    }
  }
  bestMove = Math.floor(Math.random() * (bestScores.length));

  // if (level === 1) {
  //   console.log(newBoard[0] + newBoard[1] + newBoard[2]);
  //   console.log(newBoard[3] + newBoard[4] + newBoard[5]);
  //   console.log(newBoard[6] + newBoard[7] + newBoard[8]);
  //   console.log("triesIn: " + triesIn);
  // }

  bestScores[bestMove].tries = triesRes;
  bestScores[bestMove].win = winRes;
  bestScores[bestMove].lose = loseRes;
  bestScores[bestMove].tie = tieRes;
  bestScores[bestMove].moves = moves;
  return bestScores[bestMove];
}